/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    stroke="currentColor"
    d="m3.0098 16.9926-.8994-.0004.4744.7641c3.0902 4.9777 9.5968 6.636 14.7074 3.6854 5.2134-3.01 6.9996-9.6763 3.9897-14.8897-3.01-5.2134-9.6763-6.9996-14.8897-3.9897-2.8047 1.6194-4.6985 4.3529-5.272 7.4768A.3.3 0 0 1 .53 9.9308c.605-3.2957 2.6037-6.18 5.5621-7.888C11.5926-1.133 18.626.7515 21.8015 6.252c3.1756 5.5004 1.2911 12.5337-4.2093 15.7093-5.4075 3.122-12.2968 1.3532-15.5451-3.9338l-.926-1.5071v4.9494c0 .132-.0945.2539-.2358.2867l-.0918.0081c-.1442-.0073-.2551-.1066-.2851-.2261L.5 21.447v-5.0438h5.1736c.1806 0 .3106.1411.3106.2952 0 .132-.0945.2539-.2358.2867l-.0966.0085-2.642-.001Zm7.5552-2.4163.3746.3312.3312-.3745 5.9715-6.7534a.3004.3004 0 0 1 .424-.026l.1021.0903a.3004.3004 0 0 1 .0261.424l-6.4952 7.3455a.3003.3003 0 0 1-.4189.0305l-.1013-.0857-.1305-.0243a.2967.2967 0 0 1-.1434-.0702l-3.1553-2.7901a.3004.3004 0 0 1-.026-.424l.0686-.0776a.3004.3004 0 0 1 .424-.026l2.7485 2.4303Z"
  />,
  'Revision'
);
